import { CSSProperties } from 'react';

// Host-side placeholder for the dashboard REGION while its server-assembled document is in flight: a calm
// shimmer bento standing in for the widget grid. It lets the dashboard fill in on its own instead of the
// whole home waiting behind one loop loader — the catch-up chrome above it paints immediately, exactly as
// the native apps show their home while only the dashboard loads. Fills its (positioned) parent from the top.
const ROWS: number[][] = [
  [2, 1],
  [1, 1, 1],
  [1, 2],
];

export function DashboardSkeleton() {
  return (
    <div aria-hidden style={styles.fill}>
      <div style={styles.grid}>
        {ROWS.map((row, i) => (
          <div key={i} style={styles.row}>
            {row.map((span, j) => (
              <div key={j} className="orion-shimmer" style={{ ...styles.card, flex: span }} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

// Reuse the shared `orion-shimmer` animation + sizing, but override its sweep to a NEUTRAL grey — the global
// class's mid-stop is `--accent-rgb` (the neon green), which reads as brand noise on a plain placeholder.
// Overriding only `background-image` (not the `background` shorthand) keeps the class's `background-size` and
// animation intact, and leaves every other `orion-shimmer` user untouched.
const NEUTRAL_SHIMMER =
  'linear-gradient(90deg, rgba(var(--ink-rgb),0.05) 0%, rgba(var(--ink-rgb),0.11) 50%, rgba(var(--ink-rgb),0.05) 100%)';

const styles: Record<string, CSSProperties> = {
  fill: { position: 'absolute', inset: 0, overflow: 'hidden' },
  grid: { width: '100%', maxWidth: 1080, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16 },
  row: { display: 'flex', gap: 16 },
  card: { height: 150, borderRadius: 16, backgroundImage: NEUTRAL_SHIMMER },
};
